(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($) {
  $(document).ready(function () {
    var $search = $('.search-in-page');
    $search.on('keyup', function (e) {
      var hasResult = false;
      setTimeout(function () {
        var $search = $(e.currentTarget);
        $('#main h2,#main p').hide().each(function () {
          var $this = $(this);
          var search = $search.val().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          var find = $this.text().replace(/\xa0/g, ' ').search(search) !== -1;

          if (find) {
            hasResult = true;
            $this.prev('h2').show();
            $this.next('p').show();
            $this.show();
          }
        });
        $('.no-result').toggle(!hasResult);
      }, 400);
    });
  });
})(jQuery);

},{}]},{},[1]);
